import React from "react";
import CarouselContainer from "../../components/imageSlider/ImageSlider";

import "./works.css";

export default function Works() {
  return (
    <div className="workPage" id="works">
      <div className="portfolioPage ">
        <h1>
          Project Works<span> 📝 </span>{" "}
        </h1>

        <div className="sliderWrapper">
          <CarouselContainer />

          {/* <div className="sliderLinks">
            <h5>
              Most of the projects are MERN-based minimal yet interactive
              applications crafted with in-demand technology. To preview the
              deployed Project 📲, and view code details in GitHub 💻, simply
              navigate to the respective links provided on the slider.
            </h5>
          </div> */}
        </div>
      </div>
    </div>
  );
}
